import { AnyAction, Dispatch } from "redux";
import { ApplicationStore, getStore } from "..";
import { switcher } from "src/utils";
import routes from "./routes";
import { logError } from "src/utils/logger";

let fetchOptionsCache: { url: string; referer: string };

export function getFetchOptionsFromStore() {
    if (fetchOptionsCache) {
        return fetchOptionsCache;
    }

    const appState: ApplicationStore = getStore().getState();

    const { env, referer } = appState.onlineShopper;

    fetchOptionsCache = { url: `https://${env}.api.onlineshopper.dealerinspire.com/v2`, referer };

    return fetchOptionsCache;
}

/**
 * Custom middleware to make any necessary API calls without tying async actions directly to components.
 * @param store Current state of the application.
 */
const dataService = (store: any) => (next: Dispatch) => async (action: AnyAction) => {
    try {
        next(action);
        await switcher(routes)()(action.meta?.route ?? action.type)(next, action, store);
    } catch (e) {
        // Ignore fetch errors. fetch only throws due to network issues
        if (
            e.message !== "The network connection was lost." &&
            e.message !== "Failed to fetch" &&
            e.name !== "AbortError"
        ) {
            logError(e);
        }
    }
};

export default dataService;
